import { FIELD_TYPES } from "constants/template-field-type";
import { DEVLINK_COMPONENT_CONFIGS } from "./constants/devlink-component-types";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Dynamic Devlink",
    fields: {
        devlinkComponent: {
            type: FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Component Configuration",
            conditionalKeyName: "componentType",
            options: Object.entries(DEVLINK_COMPONENT_CONFIGS).map(([componentName, config])=>({
                    text: componentName,
                    fieldsConfig: config.props || {}
                }))
        }
    }
};
